import React, { useEffect } from 'react';
import BaseDropdown from './BaseDropdown';
import { useUsecaseStructure } from './UsecaseStructureContext';

const BranchDropdown = ({ value, onChange, ...props }) => {
  const { structure, loading, error, fetchStructure, getBranches } = useUsecaseStructure();

  useEffect(() => {
    fetchStructure();
  }, []);

  const options = getBranches();

  return (
    <BaseDropdown
      options={options}
      value={value}
      onChange={onChange}
      label="Branch"
      placeholder="Select a branch"
      loading={loading}
      error={error}
      {...props}
    />
  );
};

export default BranchDropdown; 